module.exports = __webpack_public_path__ + "media/images/pattern5-cd67e4852312ae93013ab07e6da64f0c.png";